import React from "react";
import { useParams } from "react-router-dom";
import InviteManagement from "./InviteManagement";

const BusinessUnitInvitesPage = () => {
  const { businessUnitId } = useParams();

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-heading-1">Send Invites</h1>
        <p className="text-muted-foreground">
          Send user invitations for this business unit
        </p>
      </div>
      <InviteManagement businessUnitId={businessUnitId} />
    </div>
  );
};

export default BusinessUnitInvitesPage;
